import { defineComponent, ref, reactive, shallowRef, watchEffect, onUnmounted } from "vue";
import { useBasicStore } from "../../../stores/basic.mjs";
import { storeToRefs } from "pinia";
import { useI18n } from "../../../locales/index.mjs";
import TUIRoomEngine__default, { TUINetworkQuality, TUIRoomEvents } from "@tencentcloud/tuiroom-engine-js";
import useGetRoomEngine from "../../../hooks/useRoomEngine.mjs";
import IconButton from "../../common/base/IconButton.vue.mjs";
import "../../../directives/vClickOutside.mjs";
import NetworkStabilityIcon from "../../common/icons/NetworkStabilityIcon.vue.mjs";
import NetworkFluctuationIcon from "../../common/icons/NetworkFluctuationIcon.vue.mjs";
import NetworkLagIcon from "../../common/icons/NetworkLagIcon.vue.mjs";
import NetworkDisconnectedIcon from "../../common/icons/NetworkDisconnectedIcon.vue.mjs";
import ArrowStrokeUpIcon from "../../common/icons/ArrowStrokeUpIcon.vue.mjs";
import { IconButtonLayout } from "../../../constants/room.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NetworkInfo",
  setup(__props) {
    const roomEngine = useGetRoomEngine();
    const { t } = useI18n();
    const basicStore = useBasicStore();
    const { networkInfo } = storeToRefs(basicStore);
    const networkBoard = ref();
    const showNetworkInfo = ref(false);
    const isShowNetworkContainer = ref(false);
    const state = reactive({
      title: "",
      titleType: void 0,
      networkIcon: null
    });
    const qualityMap = {
      [TUINetworkQuality.kQualityExcellent]: {
        title: "Stability",
        titleType: "success",
        icon: shallowRef(NetworkStabilityIcon)
      },
      [TUINetworkQuality.kQualityPoor]: {
        title: "Fluctuation",
        titleType: "warning",
        icon: shallowRef(NetworkFluctuationIcon)
      },
      [TUINetworkQuality.kQualityVeryBad]: {
        title: "Lag",
        titleType: "danger",
        icon: shallowRef(NetworkLagIcon)
      },
      [TUINetworkQuality.kQualityDown]: {
        title: "Disconnected",
        titleType: "info",
        icon: shallowRef(NetworkDisconnectedIcon)
      }
    };
    watchEffect(() => {
      const quality = qualityMap[networkInfo.value.quality];
      if (quality) {
        isShowNetworkContainer.value = true;
        state.title = quality.title;
        state.titleType = quality.titleType;
        state.networkIcon = quality.icon;
      }
    });
    function handleClickNetworkIcon() {
      showNetworkInfo.value = !showNetworkInfo.value;
    }
    function handleClickOutSide() {
      if (showNetworkInfo.value) {
        showNetworkInfo.value = false;
      }
    }
    async function onUserNetworkQualityChanged({
      userNetworkList
    }) {
      userNetworkList.forEach((userNetwork) => {
        basicStore.setNetworkInfo(userNetwork);
      });
    }
    TUIRoomEngine__default.once("ready", () => {
      var _a;
      (_a = roomEngine.instance) == null ? void 0 : _a.on(
        TUIRoomEvents.onUserNetworkQualityChanged,
        onUserNetworkQualityChanged
      );
    });
    onUnmounted(() => {
      var _a;
      (_a = roomEngine.instance) == null ? void 0 : _a.off(
        TUIRoomEvents.onUserNetworkQualityChanged,
        onUserNetworkQualityChanged
      );
    });
    return { __sfc: true, roomEngine, t, basicStore, networkInfo, networkBoard, showNetworkInfo, isShowNetworkContainer, state, qualityMap, handleClickNetworkIcon, handleClickOutSide, onUserNetworkQualityChanged, IconButton, ArrowStrokeUpIcon, IconButtonLayout };
  }
});
export {
  _sfc_main as default
};
